
// import { Viewer } from '@photo-sphere-viewer/core';

const panoramas = document.querySelectorAll('.panorama');



panoramas.forEach(function (panorama, i) {
	console.log(panorama);

	const viewer = window.pannellum.viewer(panorama, {
		"type": "equirectangular",
		"panorama": panorama.dataset.panoramaUrl,
		"autoLoad": true,
		'mouseZoom': false,
		'keyboardZoom': false,
		'showControls': false,
		'maxPitch': 90,
		'minPitch': -90,
		minHfov: 50,
		maxHfov: window.matchMedia("(min-width: 576px)").matches ? 120 : 50
	});

	viewer.on('mousedown', hideInfo);
	viewer.on('mouseup', showInfo);
	viewer.on('touchstart', hideInfo);
	viewer.on('touchend', showInfo);
});

function hideInfo(evt) {
	console.log('mousedown', evt);
	evt.target.closest('.panorama__container').querySelector('.panorama__info').classList.add('opacity-0');
}
function showInfo(evt) {
	console.log('mouseup', evt);
	evt.target.closest('.panorama__container').querySelector('.panorama__info').classList.remove('opacity-0');
}